import { useEffect, useState } from 'react'
import CancelButton from '../../assets/UI Elements/CancelButton.svg'
import Cookies from '../../assets/UI Elements/Cookies.svg'

const CookieModal = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const cookieAccepted = localStorage.getItem('cookieAccepted')
    if (!cookieAccepted) {
      setIsVisible(true)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem('cookieAccepted', 'true')
    setIsVisible(false)
  }

  if (!isVisible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[99999] w-full sm:bottom-[20px] sm:left-[50%] sm:transform sm:-translate-x-1/2 sm:w-[896px] sm:max-w-[calc(100vw-40px)] sm:right-auto lg:w-[896px] md:w-[90vw]">
      <div className="bg-[#1B130A]/90 rounded-t-[13px] rounded-b-none shadow-lg border border-[#333]/90 px-[13px] py-[13px] sm:rounded-[13px] sm:px-[27px] sm:py-[13px] sm:bg-[#1B130A]/90 sm:border-none sm:shadow-[0px_40px_11px_0px_rgba(26,19,10,0.00),0px_25px_10px_0px_rgba(26,19,10,0.01),0px_15px_9px_0px_rgba(26,19,10,0.05),0px_7px_7px_0px_rgba(26,19,10,0.09),0px_1px_3px_0px_rgba(26,19,10,0.10)]">
        <div className="hidden sm:flex items-center">
          <img
            src={Cookies}
            alt="Cookie icon"
            width={32}
            height={32}
            className="flex-shrink-0"
            loading="lazy"
          />
          <div className="flex-1 ml-[13px] mr-[27px]">
            <p
              className="text-white text-[12px] leading-[19px] font-[500]"
              style={{ fontFeatureSettings: "'liga' off, 'clig' off" }}
            >
              Мы используем cookie для статистики и улучшения
              сайта. Используя сайт, вы соглашаетесь с нашей{' '}
              <a
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white underline hover:no-underline"
              >
                политикой конфиденциальности.
              </a>
            </p>
          </div>
          <button
            onClick={handleAccept}
            className="flex px-[11px] py-[8px] justify-center items-center gap-[8px] rounded-[11px] border border-white bg-transparent text-white text-[9px] font-medium hover:bg-white hover:text-black transition-all duration-200 flex-shrink-0"
          >
            Принять
          </button>
          <button
            onClick={handleAccept}
            className="flex-shrink-0 ml-[27px] hover:opacity-70 transition-opacity"
            aria-label="Закрыть"
          >
            <img src={CancelButton} alt="Close icon" width={16} height={16} loading="lazy" />
          </button>
        </div>
        <div className="sm:hidden">
          <div className="flex items-start justify-between mb-[16px]">
            <p
              className="text-white font-medium text-[11px] leading-[16px] flex-1 pr-[8px]"
              style={{ fontWeight: 500 }}
            >
              Мы используем cookie для статистики и улучшения
              сайта. Используя сайт, вы соглашаетесь с нашей{' '}
              <a
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white underline hover:no-underline"
              >
                политикой конфиденциальности.
              </a>
            </p>
            <button
              onClick={handleAccept}
              className="flex-shrink-0 hover:opacity-70 transition-opacity"
              aria-label="Закрыть"
            >
              <img src={CancelButton} alt="Close icon" width={13} height={13} loading="lazy" />
            </button>
          </div>
          <div className="flex justify-center">
            <button
              onClick={handleAccept}
              className="bg-transparent border border-white text-white px-[16px] py-[5px] rounded-[8px] text-[9px] font-medium hover:bg-white hover:text-black transition-all duration-200"
            >
              Принять
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CookieModal
